import React from 'react';

const Home = () => {
    return (
        <div className="container mb-5">
            <div className="min-h-screen bg-white d-flex align-items-center justify-content-center p-4 mt-4">
                <div className="text-center max-w-md">
                    {/* Logo */}
                    <div className="mb-8">
                        <img 
                            src="/android-chrome-192x192.png" 
                            alt="Cirenio" 
                            className="mx-auto"
                            style={{ width: '80px', height: '80px' }}
                        />
                    </div>

                    {/* Mensaje Principal */}
                    <h1 className="text-2xl font-semibold mb-4">
                        ¡Bienvenido a Mi Cuenta!
                    </h1>

                    {/* Descripción */}
                    <p className="text-gray-600 mb-6">
                        Para acceder a tu cuenta necesitás un link personalizado que te enviará tu financiera.
                    </p>

                    {/* Card con instrucciones */}
                    <div className="bg-gray-50 p-4 rounded-lg mb-8">
                        <h2 className="text-lg font-medium mb-3">
                            ¿Cómo obtener el link?
                        </h2>
                        <ul className="text-left text-gray-600 space-y-2 list-unstyled">
                            <li className="flex items-start">
                                <span className="mr-2">1.</span>
                                Contactá a tu financiera
                            </li>
                            <li className="flex items-start">
                                <span className="mr-2">2.</span>
                                Solicitá el acceso a tu cuenta
                            </li>
                            <li className="flex items-start">
                                <span className="mr-2">3.</span>
                                Recibirás un link único y personal
                            </li>
                        </ul>
                    </div>

                    {/* Footer */}
                    <p className="text-sm text-gray-500">
                        Si tenés dudas, consultá con tu financiera.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Home;
